import { SizeIconLarge, SizeIconMedium, SizeIconSmall, SizeIconXl, SizeIconXxl } from '@saux/design-tokens/index';
export var SAIconSize = {
    small: "" + SizeIconSmall,
    medium: "" + SizeIconMedium,
    large: "" + SizeIconLarge,
    xl: "" + SizeIconXl,
    xxl: "" + SizeIconXxl,
};
//# sourceMappingURL=icon.sizes.js.map